import { CircularProgress, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import coins from "./assets/icons/coins.svg";
import coins_light from "./assets/icons/coins_light.svg";
import { FC } from "react";
import { SkeletonBotItem } from "./SkeletonBotItem";
import CustomPaper from "../../../../_components/CustomPaper";
import AdronTypography from "../../../../_components/AdronTypography";

export const SkeletonBotScreen: FC = () => {
  const theme = useTheme();

  return (
    <>
      <Stack direction={"row"} spacing={1} sx={{ paddingTop: 0, flex: 1, width: "100%" }}>
        <CustomPaper
          fullWidth
          sx={{
            position: "relative",
            backgroundImage: `url(${theme.palette.mode === "dark" ? coins : coins_light})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "right",
            backgroundPositionX: "113%",
            backgroundSize: "43%",
            backgroundPositionY: "center",
            height: "119px",
          }}
        >
          <Stack direction="row" justifyContent="space-between" height="100%">
            <Stack direction="column" spacing={2} justifyContent="space-between">
              <Typography variant="h1" color="textSecondary">
                <CircularProgress size={30} color="primary" />
              </Typography>
              <AdronTypography style={{ maxWidth: "199px" }} value={"Grid profit"} halfOpacity />
            </Stack>
          </Stack>
        </CustomPaper>
      </Stack>
      <Stack direction={"column"} spacing={"10px"} sx={{ paddingTop: 3 }}>
        <SkeletonBotItem />
        <SkeletonBotItem />
        <SkeletonBotItem />
      </Stack>
    </>
  );
};
